import angular from 'angular';
import services from './services/register';
import handle from './middleware.handle';
import decorate from './middleware.decorate';

const moduleName = 'middleware',
    module = angular.module(moduleName, []);

services(module);

module.config(decorate)
      .run(handle);

export default moduleName;



// WEBPACK FOOTER //
// ./src/middleware/middleware.module.js